// import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';
import { initializeMuiLicense } from './config/muiLicense';
import './index.css';
import App from './App.tsx';

const initializeApp = async () => {
  await initializeMuiLicense();

  createRoot(document.getElementById('root')!).render(
    // ! uncomment
    // <StrictMode>
    <App />
    // </StrictMode>
  );
};

initializeApp();
